import { connect } from 'react-redux'
//import Analytics from 'modules/Analytics/index'
import Analytics from 'modules/Analytics/CandidateDashboard'

const mapStateToProps = () => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Analytics)
